import OktaAuth from '@okta/okta-auth-js';
import {Security as OktaSecurity} from '@okta/okta-react';
import {OnAuthRequiredFunction, RestoreOriginalUriFunction} from '@okta/okta-react/bundles/types/OktaContext';

import {StaticConfig} from 'config/staticConfig';

interface SecurityProps {
  oktaAuth: OktaAuth;
  onAuthRequired: OnAuthRequiredFunction;
  restoreOriginalUri: RestoreOriginalUriFunction;
  children: React.ReactNode;
}

const Security = (props: SecurityProps) =>
  StaticConfig.mobileApplicationLoader ? <>{props.children}</> : <OktaSecurity {...props} />;

export default Security;
